import { render, staticRenderFns } from "./Detail-Supplier.vue?vue&type=template&id=5b10a275"
import script from "./Detail-Supplier.vue?vue&type=script&lang=js"
export * from "./Detail-Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports